import React, { useEffect } from "react";
import { Col, Row, Card, Breadcrumb } from "antd";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchNewsItemAsync, selectNewsItem } from "../features/news/newsSlice";
import { getImageURL } from "../util/images";
import { WysiwygDisplay } from "../components/WysiwygDisplay";

export default function NewsItem() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const data = useSelector((state) => selectNewsItem(state, id));
    const status = useSelector((state) => state.news.status);
    const error = useSelector((state) => state.news.error);

    useEffect(() => {
        if (status === "idle" && !data) {
            dispatch(fetchNewsItemAsync(id));
        }
    }, [dispatch, status, data, id]);

    if (status === "pending" || !data) return <div className="AlertInfo Loading">Loading...</div>;
    if (error) return <p>Error :(</p>;

    return (
        <div className="NewsSingle PageSingle">
            <div className="AppContainer">
                <Breadcrumb
                    className="Breadcrumb"
                    items={[
                        {
                            title: <Link to="/">Home</Link>,
                        },
                        {
                            title: <Link to="/courses">News</Link>,
                        },
                        {
                            title: data.attributes.Title,
                        },
                    ]}
                />
                <Row gutter={[20, 20]}>
                    <Col xs={{ span: 24, order: 2 }} md={{ span: 16, order: 1 }}>
                        <Card bordered={false} className="CardItem">
                            <h1 className="title">{data.attributes.Title}</h1>
                            <div className="CardMeta">
                                <time>
                                    {new Date(data.attributes.publishedAt).toLocaleDateString("en-gb", {
                                        day: "numeric",
                                        month: "long",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    })}
                                </time>
                            </div>
                            <WysiwygDisplay data={data.attributes.Description} />
                        </Card>
                    </Col>
                    <Col xs={{ span: 24, order: 1 }} md={{ span: 8, order: 2 }}>
                        <Card
                            bordered={false}
                            className="CardItem"
                            bodyStyle={{ padding: 0 }}
                            cover={<img alt="" src={getImageURL(data.attributes.Cover.data?.attributes.url)} />}
                        ></Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
